import Container from "react-bootstrap/esm/Container";
import newsImage1 from "../images/news-image-1.png"

export default function News() {
  return (
    <>
      <Container className={"news-page"}>
        <h2 id="config_header">May 05, 2023</h2>
        <div className="bottom-line"></div>
        <p className="config_lead">Element Data app can now run on Raspberry Pi, Docker and CLI! </p>
        <p className="config_lead">New builds are available in the Download section, under Linux </p>
        <p className="config_lead">Instructions are bundled in the zip file with the executables.</p>
        <p className="config_lead">For the Docker version, make sure to check the Tags to download the right version for you.</p>
        <p className="config_lead">Available Linux builds: GUI x64, CLI x64, CLI arm32, CLI arm64</p>

        <h2 id="config_header">April 18, 2023</h2>
        <div className="bottom-line"></div>
        <p className="config_lead">Update on latest vote :</p>
        <p className="config_lead">As you already know, a majority of people voted for option #1</p>
        <p className="config_lead">[A] Minimum amount of 250 IAQ is required to receive your balance (AKA, you don't get your daily payout unless you have the minimum amount, but balance increases)</p>
        <p className="config_lead">Changes have been made and will be effective for the next payout tomorrow.
          You can already see your new combined IAQ balance in your account page, It includes the amount of IAQ tokens you have in your connected wallet + staked on Cometa.</p>
        <p className="config_lead">A <strong>minimum of 250 IAQ or 5 LP tokens</strong> are now required <strong>per device</strong> in order to receive your next payout.</p>
        <p className="config_lead"><i>You can still have multiple devices connected to the same wallet but the minimum is calculated per device. Which means if you have for example 2 devices and 450 IAQ in your wallet, only the first device will receive the daily payout.</i></p>
        <p className="config_lead">Thanks again for parcipating in the latest community vote and have a great day!</p>

        <h2 id="config_header">Farming</h2>
        <div className="bottom-line"></div>
        <p className="config_lead">Tinyman has selected Element Data (IAQ) to be part of their farms for Governance Period #7!</p>
        <a href="https://tinymanorg.medium.com/tinyman-targeted-defi-rewards-farms-23407f29bf64" target="_blank">Tinyman Launches Farms for “Targeted Defi Rewards”</a>
        <br />
        <br />
        <p className="config_lead">LPs holders will be able to farm them on Tinyman for even more rewards!</p>
        <p className="config_lead">You can access the farming pool and get more details here:</p>
        <a href="https://app.tinyman.org/#/pool/ED57RDPEG53HHJKAHQGFBF74GUZ5JHH464424OZ4NSOJVV5VAL5YLZXQ5U/farming-programs/16" target="_blank">Tinyman IAQ Farm</a>
        <br />
        <br />
        <p className="config_lead">First cycle starts in 5 days, get your LPs ready!</p>
        <h2 id="config_header">April 17, 2023</h2>
        <div className="bottom-line"></div>
        <p className="config_lead">Our vote on Discord has ended!</p>
        <p className="config_lead">Option 1 will be effective later this week.</p>
        <p className="config_lead">There will be an announcement when it is in place.</p>
        <img src={newsImage1} alt="news-voting" />
        <br />
        <br />
        <br />
        <br />
      </Container>
    </>
  )
}
